module.exports = __webpack_public_path__ + "img/gj_9.83b14bca.jpg";